const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
  IS_PRODUCTION: import.meta.env.VITE_ENVIRONMENT === 'production',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  CLARITY_ID: import.meta.env.VITE_CLARITY_ID,
  MICROSOFT_CLIENT_ID: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
  MICROSOFT_TENANT_ID: import.meta.env.VITE_MICROSOFT_TENANT_ID,
  REDIRECT_URI: import.meta.env.VITE_REDIRECT_URI
}

export default env
